import { EventListeners, MinzeElement, Reactive } from 'minze'
import { EventData } from './lvc-event-series-calendar'
import { Locale } from '../../modules/locale'
import { formatEventDateTime, formatStartTime } from '../../modules/date'
import { Font } from '../../constants'
import { getCardPlaceholder } from '../../modules/utils'

Locale.getInstance().registerKeySet('fr', 'eventSeries', {
  showMore: 'Voir plus',
  showLess: 'Voir moins',
  exhibtionsTitle: 'Expositions',
  eventSeriesTitle: 'Séries',
  eventsTitle: 'Événements',
})

Locale.getInstance().registerKeySet('en', 'eventSeries', {
  showMore: 'Show more',
  showLess: 'Show less',
  exhibtionsTitle: 'Exhibitions',
  eventSeriesTitle: 'Series',
  eventsTitle: 'Events',
})
const language = Locale.language
export interface LvcEventSeriesList {
  dataEvents: string
  dataExhibitions: string
  dataEventSeries: string
  renderedExhibitionItems: number
  renderedEventSeriesItems: number
}

export class LvcEventSeriesList extends MinzeElement {
  attrs = [
    'data-events',
    'data-exhibitions',
    'data-event-series',
    'data-exhibitions-init-render-limit',
    'data-event-series-init-render-limit',
  ]
  reactive: Reactive = [
    ['renderedExhibitionItems', 2],
    ['renderedEventSeriesItems', 2],
  ]
  defaultExhibitionRenderLimit = 2
  defaultEventSeriesRenderLimit = 2
  /*
  Change behaviour here, we will only show 2 exhibitions and series on load.

  We will then display a "showMore" button, onClick it will display ALL of that type of event.
  We will then display a "showLess" button, onClick it will return the event list to the default state (2 being displayed).
  */

  decodeObject = (json: string) => {
    if (json === undefined) {
      return null
    }
    return JSON.parse(decodeURIComponent(json))
  }
  showMore(type: string) {
    switch (type) {
      case 'exhibitions':
        this.renderedExhibitionItems = this.decodeObject(this.dataExhibitions)?.length
        break
      case 'eventSeries':
        this.renderedEventSeriesItems = this.decodeObject(this.dataEventSeries)?.length
        break
    }
  }
  showLess = (type: string) => {
    switch (type) {
      case 'exhibitions':
        this.renderedExhibitionItems = this.defaultExhibitionRenderLimit
        break
      case 'eventSeries':
        this.renderedEventSeriesItems = this.defaultEventSeriesRenderLimit
        break
    }
  }

  html = () => {
    const exhibitionsCount = this.decodeObject(this.dataExhibitions)?.length || 0
    const eventsCount = this.decodeObject(this.dataEvents)?.length || 0
    const eventSeriesCount = this.decodeObject(this.dataEventSeries)?.length || 0

    const exhibitions =
      this.decodeObject(this.dataExhibitions)?.slice(0, this.renderedExhibitionItems) ?? []

    const eventSeries =
      this.decodeObject(this.dataEventSeries)?.slice(0, this.renderedEventSeriesItems) ?? []

    const events = (this.decodeObject(this.dataEvents) ?? []).sort((a: any, b: any) => {
      if (a?.startDate > b?.startDate) {
        return 1
      } else if (b?.startDate > a?.startDate) {
        return -1
      } else {
        return 0
      }
    })

    return `
    ${
      this.dataExhibitions && exhibitionsCount > 0
        ? `
    <div class="exhibitions-section">
      <div class="title-wrapper">
        <div class="event-type-title">${Locale.getKey('eventSeries.exhibtionsTitle')} (${exhibitionsCount})</div>
      </div>
      <div class="event-cards">
        <lvc-search-result-block
          results="${encodeURIComponent(JSON.stringify(exhibitions))}"
          enable-date-blocks="false"
          data-component-location="programmation"
        >
        </lvc-search-result-block>
        ${
          exhibitionsCount > this.renderedExhibitionItems
            ? `
          <div class="button-container">
            <button id="show-more-exhibitions" class="button_blue">${Locale.getKey('eventSeries.showMore')}</button>
          </div>
        `
            : ''
        }
        ${
          exhibitionsCount === this.renderedExhibitionItems &&
          exhibitionsCount !== this.defaultExhibitionRenderLimit
            ? `
          <div class="button-container">
            <button id="show-less-exhibitions" class="button_blue">${Locale.getKey('eventSeries.showLess')}</button>
          </div>
        `
            : ''
        }
      </div>
    </div>
    `
        : ''
    }
    ${
      this.dataEventSeries && eventSeriesCount > 0
        ? `
    <div class="event-series-section">
      <div class="title-wrapper">
        <div class="event-type-title">${Locale.getKey('eventSeries.eventSeriesTitle')} (${eventSeriesCount})</div>
      </div>
      <div class="event-cards">
        <lvc-search-result-block
          results="${encodeURIComponent(JSON.stringify(eventSeries))}"
          enable-date-blocks="false"
          data-component-location="programmation"
        >
        </lvc-search-result-block>
        ${
          eventSeriesCount > this.renderedEventSeriesItems
            ? `
        <div class="button-container">
          <button id="show-more-event-series" class="button_blue">${Locale.getKey('eventSeries.showMore')}</button>
        </div>
      `
            : ''
        }
      ${
        eventSeriesCount === this.renderedEventSeriesItems &&
        eventSeriesCount !== this.defaultEventSeriesRenderLimit
          ? `
        <div class="button-container">
          <button id="show-less-event-series" class="button_blue">${Locale.getKey('eventSeries.showLess')}</button>
        </div>
      `
          : ''
      }


      </div>
    </div>
    `
        : ''
    }
      ${
        this.dataEvents && eventsCount > 0
          ? `
      <div class="events-section">
        <div class="title-wrapper">
          <div class="event-type-title">${Locale.getKey('eventSeries.eventsTitle')} (${eventsCount})</div>
        </div>
        <div class="event-cards">
          <lvc-search-result-block
            results="${encodeURIComponent(JSON.stringify(events))}"
            enable-date-blocks="false"
            data-component-location="programmation"
          >
          </lvc-search-result-block>
        </div>
      </div>
      `
          : ''
      }
      `
  }

  css = () => `
  .events-section,
  .exhibitions-section {
    margin: 0 auto;
  }
  .event-cards {
    gap: 16px;
  }

  .event-card-wrapper {
    border-bottom: 1px solid rgba(30, 0, 125, 0.3);
  }
  .title-wrapper {
    padding-bottom: 1rem;
    border-bottom: 1px solid rgba(30, 0, 125, 0.3);
  }
  .event-type-title {
    text-size: 1rem;
    color: #1E007D;
    font-weight: 700;
    line-height: 1;
  }
  .event-card-wrapper:last-child {
    border-bottom: none;
  }
  .button-container {
    margin-top: 2rem;
    display: flex;
  }
  button {
    font-family: inherit;
    font-weight: ${Font.weight.medium};
  }
  .button_blue {
    padding: 11px 20px;
    justify-content: center;
    align-items: center;
    grid-column-gap: 0.4rem;
    border-radius: 5rem;
    background-color: #1e007d;
    transition: box-shadow 300ms ease;
    background-color: #ffff;
    color: #1E007D;
    font-size: 14px;
    line-height: 16.8px;
    text-decoration: none;
    border: none;
    margin: auto;
    cursor: pointer;
  }
 `

  eventListeners: EventListeners = [
    ['#show-more-exhibitions', 'click', () => this.showMore('exhibitions')],
    ['#show-less-exhibitions', 'click', () => this.showLess('exhibitions')],
    ['#show-more-event-series', 'click', () => this.showMore('eventSeries')],
    ['#show-less-event-series', 'click', () => this.showLess('eventSeries')],
    // ["#show-less-exhibitions", "click", () => this.toggleDisplay("exhibitions", false)],
    // ["#show-less-event-series", "click", () => this.toggleDisplay("eventSeries", false)],
    // ["#show-less-events", "click", () => this.toggleDisplay("events", false)],
  ]
}
